var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.6163 0H5.30951C2.41031 0 0 2.49409 0 5.57143V33.4286C0 36.5059 2.41039 39 5.30875 39H37.6155C40.5896 39 43 36.5059 43 33.4286V5.57143C43.0008 2.49409 40.6619 0 37.6163 0ZM9.34786 5.57143C11.5782 5.57143 13.3862 7.44221 13.3862 9.75C13.3862 12.0578 11.6531 13.9286 9.34786 13.9286C7.04264 13.9286 5.30951 12.0578 5.30951 9.75C5.30951 7.44221 7.19239 5.57143 9.34786 5.57143ZM36.3459 33.4286C36.8423 33.4286 37.2966 33.15 37.5322 32.6973C37.7677 32.2359 37.7425 31.6875 37.4657 31.2631L26.6968 14.5488C26.4477 14.1612 26.0229 13.9286 25.577 13.9286C25.1311 13.9286 24.7104 14.1636 24.4572 14.6236L16.6076 26.7328L13.8767 22.858C13.6231 22.4982 13.2179 22.2857 12.7889 22.2857C12.3598 22.2857 11.956 22.4946 11.7022 22.8577L5.81296 31.2148C5.51437 31.6388 5.47105 32.1996 5.70073 32.6669C5.93041 33.1344 6.39389 33.4286 6.90045 33.4286H36.3459Z",
  fill: "#848484"
});

function SvgGalleryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 39,
    viewBox: "0 0 43 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/GalleryIcon.55ac7d99fb71783b161038585e100fbc.svg";
export { ForwardRef as ReactComponent };